import { render, staticRenderFns } from "./DoctorSurgeryPrices.vue?vue&type=template&id=44e63fda&scoped=true"
import script from "./DoctorSurgeryPrices.vue?vue&type=script&lang=js"
export * from "./DoctorSurgeryPrices.vue?vue&type=script&lang=js"
import style0 from "./DoctorSurgeryPrices.vue?vue&type=style&index=0&id=44e63fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e63fda",
  null
  
)

export default component.exports